import styled from 'styled-components';
interface DropDownProps {
    width?: string;
    justify_content?: string;
}

export const DropDownWrapper = styled.div<DropDownProps>`
    position: relative;
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.colors.dropDown.background};
    border: 1px solid ${({ theme }) => theme.colors.dropDown.border};
    padding: 3px 12px;
    border-radius: 4px 0 0 4px;
    border-right: 0;
    height: 36px;
    cursor: pointer;
    
    width: ${({ width }) => width || '300px'};
    @media only screen and (max-width: 1440px) {
        width: 300px;
    }

    .heading {
        padding-right: 15px;
        margin-right: -5px;
        font-size: 0.7rem;
        display: flex;
        align-items: center;
        line-height: 1.25;
    }

    .initial-mark {
        border-radius: 50%;
        height: 25px;
        width: 25px;
        display: flex;
        color: ${({ theme }) => theme.colors.text.white};
        padding: 3px;
        font-size: 0.6rem;
        font-weight: 600;
        justify-content: center;
        align-items: center;

        &.master {
            background: ${({ theme }) => theme.colors.dropDown.status.master};
        }
        &.draft {
            background: ${({ theme }) => theme.colors.dropDown.status.draft};
        }
        &.published {
            background: ${({ theme }) => theme.colors.dropDown.status.published};
        }
        &.shared {
            background: ${({ theme }) => theme.colors.dropDown.status.shared};
        }
    }
`;

export const DropdownIcon = styled.button`
    border: 1px solid transparent;
    background: transparent;
    cursor: pointer;
    marginleft: 'auto';
    height: 36px;
    border-radius: 0 4px 4px 0;
    border: 1px solid ${({ theme }) => theme.colors.dropDown.border};
    background: ${({ theme }) => theme.colors.dropDown.background};
`;

export const NewItemIcon = styled.button`
    border: 1px solid transparent;
    background: transparent;
    cursor: pointer;
`;

export const DropDownOptionsList = styled.ul<DropDownProps>`
    position: absolute;
    background: ${({ theme }) => theme.colors.dropDown.background};
    padding: 10px;
    top: 35px;
    left: 0;
    z-index: 11;
    box-shadow: ${({ theme }) => theme.colors.shadow.ddd} 0px 2px 6px 2px;
    width: ${({ width }) => width || '300px'};

    .dd-wide: {
        width: 600px;
    }

    .dd-heading {
        margin: 0 0 5px 0;
        font-size: 0.7rem;
        color: ${({ theme }) => theme.colors.text.lightGrey};
        cursor: pointer;
    }

    .dd-item {
        margin: 5px 0px;
        font-size: 0.75rem;
        display: flex;
        justify-content: ${({ justify_content }) => justify_content || 'space-between'};
        cursor: pointer;
        padding: 5px;
        align-items: center;
        font-weight: 500;
        box-shadow: ${({ theme }) => theme.colors.shadow.ddd} 0px 5px 5px -3px;

        &:hover {
            background: ${({ theme }) => theme.colors.dropDown.item.hover};
        }

        .comment-icon {
            width: 5%;
        }

        .info-icon {
            border-radius: 50%;
            height: 15px;
            width: 15px;
            display: flex;
            color: ${({ theme }) => theme.colors.dropDown.item.infoIcon.color};
            background: ${({ theme }) => theme.colors.dropDown.item.infoIcon.background};
            padding: 3px;
            font-size: 0.6rem;
            font-weight: 600;
            justify-content: center;
            align-items: center;
        }
    }

    .separator {
        margin: 15px 0;
        border-bottom: 1px solid ${({ theme }) => theme.colors.border.ccc};
    }
`;
